import { rem } from "@certn/cascadia/utils";
import { formatFileSize, formatFileTypes } from "@certn/utils";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { Text } from "../../../foundations/typography/Text";
import { useMediaQuery } from "../../utils";

interface Props {
  fileTypes?: string[];
  maxSizeBytes?: number;
}

export function FileInputInfoRAC(props: Props) {
  const { t, i18n } = useTranslation();

  const { fileTypes, maxSizeBytes } = props;

  const { mediaQuery } = useMediaQuery();

  const listFormatter = new Intl.ListFormat(i18n.language, {
    style: "short",
    type: "disjunction",
  });

  const fileTypesList = listFormatter.format(formatFileTypes(fileTypes));

  const maxSizeFormatted =
    typeof maxSizeBytes === "number"
      ? t("(max {{size}})", {
          size: formatFileSize(maxSizeBytes),
        })
      : undefined;

  return (
    <div
      className={css(
        styles.wrapper,
        mediaQuery({
          paddingBottom: [rem("space-4"), rem("space-5")],
        })
      )}
    >
      <Text color="text-weak" align="center">
        {[fileTypesList, maxSizeFormatted].filter(Boolean).join(" ")}
      </Text>
    </div>
  );
}

const styles = {
  wrapper: css({
    display: "flex",
    justifyContent: "center",
  }),
};
